import React from "react";
import { HeaderActionArea, styled } from "@deere/fuel-react"; // Import components from Deere's UI library
import { LocationOn } from "@mui/icons-material"; // Import icon from Material-UI

// Define a styled button using Material-UI's styling system
const StyledButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: theme.palette.primary.main,
  color: "#fff",
  padding: "8px 16px",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
}));

// Define a functional component named HeaderPopJD
export default function HeaderPopJD() {
  // Function to handle the click event for finding a dealer
  const handleFindDealerClick = () => {
    window.location.href = "https://dealerlocator.deere.com/";
  };
  return (
    // Header action area to hold the styled button
    <HeaderActionArea>
      <StyledButton startIcon={<LocationOn />} onClick={handleFindDealerClick}>
        Find a Dealer
      </StyledButton>
    </HeaderActionArea>
  );
}
